const FieldsDef = {
  electronic_part: [
    {
      type: 'index',
      width: 50,
      align: 'center'
    },
    {
      key: 'part_category_id',
      title: 'Category',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'name',
      title: 'English Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'chinese_name',
      title: 'Chinese Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'mpn',
      title: 'MPN',
      minWidth: 120,
      slot: 'auditPropsCell'
    },
    {
      key: 'brand',
      title: 'Brand',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'specification',
      title: 'Specification',
      minWidth: 220,
      slot: 'auditPropsCell'
    },
    {
      key: 'description',
      title: 'Description',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'reviewed',
      title: 'Modification State',
      minWidth: 80,
      slot: 'auditPropsCell'
    },
    {
      key: 'lifecycle_status',
      title: 'Lifecycle Status',
      minWidth: 80,
      slot: 'auditPropsCell'
    },
    {
      key: 'user.name',
      title: 'Changed By',
      align: 'center',
      minWidth: 120,
      slot: 'propsCell'
    },
    {
      key: 'created_at',
      title: 'Changed Time',
      align: 'center',
      minWidth: 130
    }
  ],
  circuit_board: [
    {
      type: 'index',
      width: 50,
      align: 'center'
    },
    {
      key: 'part_category_id',
      title: 'Category',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'name',
      title: 'English Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'chinese_name',
      title: 'Chinese Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'specification',
      title: 'Specification',
      minWidth: 220,
      slot: 'auditPropsCell'
    },
    {
      key: 'description',
      title: 'Description.',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'reviewed',
      title: 'Modification State.',
      minWidth: 80,
      slot: 'auditPropsCell'
    },
    {
      key: 'user.name',
      title: 'Changed By',
      align: 'center',
      minWidth: 120,
      slot: 'propsCell'
    },
    {
      key: 'created_at',
      title: 'Changed Time',
      align: 'center',
      minWidth: 130
    }
  ],
  assembled_part: [
    {
      type: 'index',
      width: 50,
      align: 'center'
    },
    {
      key: 'part_category_id',
      title: 'Category',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'name',
      title: 'English Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'chinese_name',
      title: 'Chinese Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'specification',
      title: 'Specification',
      minWidth: 220,
      slot: 'auditPropsCell'
    },
    {
      key: 'description',
      title: 'Description.',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'reviewed',
      title: 'Modification State.',
      minWidth: 80,
      slot: 'auditPropsCell'
    },
    {
      key: 'user.name',
      title: 'Changed By',
      align: 'center',
      minWidth: 120,
      slot: 'propsCell'
    },
    {
      key: 'created_at',
      title: 'Changed Time',
      align: 'center',
      minWidth: 130
    }
  ],
  mechanical_part: [
    {
      type: 'index',
      width: 50,
      align: 'center'
    },
    {
      key: 'part_category_id',
      title: 'Category',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'name',
      title: 'English Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'chinese_name',
      title: 'Chinese Name',
      minWidth: 110,
      slot: 'auditPropsCell'
    },
    {
      key: 'specification',
      title: 'Specification',
      minWidth: 220,
      slot: 'auditPropsCell'
    },
    {
      key: 'description',
      title: 'Description.',
      minWidth: 180,
      slot: 'auditPropsCell'
    },
    {
      key: 'reviewed',
      title: 'Modification State.',
      minWidth: 80,
      slot: 'auditPropsCell'
    },
    {
      key: 'user.name',
      title: 'Changed By',
      align: 'center',
      minWidth: 120,
      slot: 'propsCell'
    },
    {
      key: 'created_at',
      title: 'Changed Time',
      align: 'center',
      minWidth: 130
    }
  ]
}

export default FieldsDef
